<template>
    <table width="100%">
        <tbody>
            <tr style="background-color: #f5f5f5">
                <td colspan="2">
                    <strong>CONFIGURACIÓN DE SERVICIOS DE PETROMIL</strong>
                </td>
            </tr>

            <tr>
                <td>ENERGIA EN RUTA: CODIGO_EDS</td>
                <td class="text-right">
                    <input type="text" class="form-control" v-model="localPetromil.energia_ruta.codigo_eds" />
                </td>
            </tr>

            <tr>
                <td>ENERGIA EN RUTA: USUARIO</td>
                <td class="text-right">
                    <input type="text" class="form-control" v-model="localPetromil.energia_ruta.usuario" />
                </td>
            </tr>

            <tr>
                <td>ENERGIA EN RUTA: CLAVE</td>
                <td class="text-right">
                    <input type="text" class="form-control" v-model="localPetromil.energia_ruta.clave" />
                </td>
            </tr>

            <tr>
                <td>ENERGIA EN RUTA: PRODUCCIÓN</td>
                <td class="text-left">
                    <input type="checkbox" v-model="localPetromil.energia_ruta.produccion"
                        style="transform: scale(1.5); margin-right: 10px" />
                </td>
            </tr>

            <tr>
                <td colspan="2"><br /></td>
            </tr>

            <tr style="background-color: #f5f5f5">
                <td colspan="2">
                    <strong>HOMOLOGACIONES DE PRODUCTOS PETROMIL</strong>
                </td>
            </tr>

            <tr>
                <td colspan="2">
                    <div class="tabla-homologaciones">
                        <table class="table table-bordered table-sm" width="100%">
                            <thead>
                                <tr style="background-color: #efefef">
                                    <th style="width:20%">CÓDIGO LOCAL</th>
                                    <th style="width:25%">NOMBRE LOCAL</th>
                                    <th style="width:20%">CÓDIGO PROVEEDOR</th>
                                    <th style="width:25%">NOMBRE PROVEEDOR</th>
                                    <th style="width:10%" class="text-center">ACCIÓN</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, index) in petromil.homologaciones_productos" :key="index">
                                    <td><input type="text" class="form-control" v-model="item.codigo_producto_local"
                                            placeholder="Ej: 002" /></td>
                                    <td><input type="text" class="form-control" v-model="item.nombre_local"
                                            placeholder="Ej: ACPM" /></td>
                                    <td><input type="text" class="form-control" v-model="item.codigo_producto_proveedor"
                                            placeholder="Ej: 010" /></td>
                                    <td><input type="text" class="form-control" v-model="item.nombre_proveedor"
                                            placeholder="Ej: DIESEL" /></td>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-danger btn-sm"
                                            @click="eliminarHomologacion(index)">
                                            Eliminar
                                        </button>
                                    </td>
                                </tr>

                                <tr v-if="petromil.homologaciones_productos.length === 0">
                                    <td colspan="5" class="text-center">
                                        No hay homologaciones agregadas.
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="text-right mt-2">
                            <button type="button" class="btn btn-secondary" @click="agregarHomologacion">
                                Agregar homologación
                            </button>
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "PetromilConfig",

    props: {
        petromil: {
            type: Object,
            required: true
        }
    },

    emits: ["update:petromil"],

    data() {
        return {
            localPetromil: JSON.parse(JSON.stringify(this.petromil))
        };
    },

    watch: {
        petromil: {
            immediate: true,
            deep: true,
            handler(value) {
                this.localPetromil = JSON.parse(JSON.stringify(value))
            }
        },

        localPetromil: {
            deep: true,
            handler(value) {
                this.$emit("update:petromil", JSON.parse(JSON.stringify(value)));
            }
        }
    },

    methods: {
        crearFilaHomologacion() {
            return {
                codigo_producto_local: "",
                codigo_producto_proveedor: "",
                nombre_local: "",
                nombre_proveedor: ""
            };
        },

        agregarHomologacion() {
            this.localPetromil.homologaciones_productos.push(this.crearFilaHomologacion());
        },

        eliminarHomologacion(index) {
            this.localPetromil.homologaciones_productos.splice(index, 1);
        }
    }
};
</script>

<style scoped>
.tabla-homologaciones {
    width: 100%;
}

.table th,
.table td {
    vertical-align: middle;
}

.mt-2 {
    margin-top: 10px;
}
</style>